import { render, staticRenderFns } from "./ControlDeviceItem.vue?vue&type=template&id=2a8a4279"
import script from "./ControlDeviceItem.vue?vue&type=script&lang=ts"
export * from "./ControlDeviceItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports